// Fixed set of "Game of the Year" award categories. Keep this in one place so the section that
// lists a year's awards and the form that lets you assign winners always stay in sync.
export const GOTY_CATEGORIES = [
  { value: 'best_new_ip', label: 'Favorite New IP' },
  { value: 'best_multiplayer', label: 'Favorite Multiplayer' },
  { value: 'best_writing', label: 'Favorite Writing' },
  { value: 'best_art_style', label: 'Favorite Art Style' },
  { value: 'best_music', label: 'Favorite Music' },
  { value: 'sound_design', label: 'Favorite Sound Design' },
  { value: 'indie', label: 'Favorite Indie' },
  { value: 'favorite_character', label: 'Favorite Character' },
  { value: 'best_performance', label: 'Favorite Performance' },
  { value: 'favorite_moment', label: 'Favorite Moment' },
  { value: 'biggest_surprise', label: 'Biggest Surprise' },
  { value: 'most_anticipated', label: 'Most Anticipated' },
  { value: 'game_of_the_year', label: 'Game of the Year' },
];

// Every category has a single winner (rank 1), except Game of the Year, which is a top 5.
export function ranksForCategory(categoryValue) {
  return categoryValue === 'game_of_the_year' ? [1, 2, 3, 4, 5] : [1];
}

// These categories additionally ask for an actor + character, alongside the usual title/poster.
export const PERFORMANCE_CATEGORIES = ['best_performance'];

// These categories additionally ask for just a character name (no actor), alongside the usual
// title (the game) and poster. Shares the same `character_name` column as PERFORMANCE_CATEGORIES.
export const CHARACTER_CATEGORIES = ['favorite_character'];
